import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchMe, clearToken, getToken } from "./AdminAuth";

export default function ProtectedRoute({ children }) {
  const [ok, setOk] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    const check = async () => {
      if (!getToken()) {
        navigate("/admin/login", { replace: true });
        return;
      }
      try {
        await fetchMe();
        if (active) setOk(true);
      } catch {
        clearToken();
        navigate("/admin/login", { replace: true });
      }
    };
    check();
    return () => {
      active = false;
    };
  }, [navigate]);

  if (ok === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-deep-brown">
        <p className="font-sans text-[11px] uppercase tracking-[0.3em] text-bronze-light">Loading…</p>
      </div>
    );
  }
  return children;
}
